<template>
  <v-badge
    :value="count > 0"
    :content="count"
    color="primary"
    bordered
    overlap
  >
    <v-btn elevation="0" class="ml-2" @click="$emit('click')">
      <v-icon left>
        mdi-filter
      </v-icon>

      {{ $t("label.button.filters") }}
    </v-btn>
  </v-badge>
</template>

<script>
export default {
  name: "FiltersButton",

  props: {
    count: { type: Number, default: 0 },
  },
};
</script>
